const HOUR_IN_MINUTES = 60;
const DAY_IN_HOURS = 24;

/** Condense a guidance message's markdown into a single-line label for the jump-to list. */
export function getGuidancePreviewLabel(text: string): string {
    const firstLine = text
        .split("\n")
        .map((line) => line.trim())
        .find((line) => line.length > 0);
    if (!firstLine) return "Suggestion";

    return (
        firstLine
            .replace(/^#{1,6}\s+/, "") // heading markers
            .replace(/^[-*+]\s+/, "") // unordered bullets
            .replace(/^\d+\.\s+/, "") // ordered bullets
            .replace(/[*_`~>]/g, "") // emphasis / code / quote markers
            .trim() || "Suggestion"
    );
}

/** A short, human-readable "how long ago" for the jump-to list. */
export function formatRelativeTime(timestamp?: string): string {
    if (!timestamp) return "";
    const then = new Date(timestamp).getTime();
    if (Number.isNaN(then)) return "";

    const minutes = Math.floor((Date.now() - then) / 60000);
    if (minutes < 1) return "just now";
    if (minutes < HOUR_IN_MINUTES) return `${minutes}m ago`;

    const hours = Math.floor(minutes / HOUR_IN_MINUTES);
    if (hours < DAY_IN_HOURS) return `${hours}h ago`;

    return `${Math.floor(hours / DAY_IN_HOURS)}d ago`;
}
